export function buildPhoneRegex(countryCode: string): RegExp {
    // Escape the '+' sign if it exists in the country code
    const escapedCode = countryCode.replace('+', '\\+');
  
    // Build regex pattern to exclude +<code>, 00<code>, or just <code> at the beginning
    const pattern = `^(?!\\s*(\\+|00)?${escapedCode})`;
  
    return new RegExp(pattern);
  }
  